import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
export class SectionStateService {
    constructor() {
        this.states = new Map();
        this.STORAGE_PREFIX = 'doctor_state_';
    }
    // ========== PERSISTENCIA ==========
    getStorageKey(sectionId) {
        const userId = localStorage.getItem('userId') || 'anonymous';
        return `${this.STORAGE_PREFIX}${sectionId}_${userId}`;
    }
    saveToStorage(sectionId, state) {
        try {
            const key = this.getStorageKey(sectionId);
            localStorage.setItem(key, JSON.stringify({
                activeTabIndex: state.activeTabIndex,
                currentView: state.currentView
            }));
        }
        catch (e) {
            console.warn('Error saving state to localStorage:', e);
        }
    }
    loadFromStorage(sectionId) {
        try {
            const key = this.getStorageKey(sectionId);
            const stored = localStorage.getItem(key);
            if (stored) {
                return JSON.parse(stored);
            }
        }
        catch (e) {
            console.warn('Error loading state from localStorage:', e);
        }
        return null;
    }
    /**
     * Limpia el estado persistido para un usuario específico o el actual
     * Llamar desde logout para limpiar el estado
     */
    clearPersistedState(sectionId) {
        try {
            const userId = localStorage.getItem('userId') || 'anonymous';
            if (sectionId) {
                localStorage.removeItem(`${this.STORAGE_PREFIX}${sectionId}_${userId}`);
            }
            else {
                // Limpiar todos los estados del usuario
                const keysToRemove = [];
                for (let i = 0; i < localStorage.length; i++) {
                    const key = localStorage.key(i);
                    if (key && key.startsWith(this.STORAGE_PREFIX) && key.endsWith(`_${userId}`)) {
                        keysToRemove.push(key);
                    }
                }
                keysToRemove.forEach(key => localStorage.removeItem(key));
            }
        }
        catch (e) {
            console.warn('Error clearing persisted state:', e);
        }
    }
    // ========== ESTADO ==========
    getState(sectionId) {
        if (!this.states.has(sectionId)) {
            this.initializeSection(sectionId);
        }
        return this.states.get(sectionId).asObservable();
    }
    getCurrentState(sectionId) {
        if (!this.states.has(sectionId)) {
            this.initializeSection(sectionId);
        }
        return this.states.get(sectionId).value;
    }
    /**
     * Verifica si hay estado persistido para esta sección
     */
    hasPersistedState(sectionId) {
        return this.loadFromStorage(sectionId) !== null;
    }
    /**
     * Obtiene el estado persistido sin inicializar la sección
     */
    getPersistedState(sectionId) {
        return this.loadFromStorage(sectionId);
    }
    initializeSection(sectionId) {
        // Intentar cargar estado persistido
        const persisted = this.loadFromStorage(sectionId);
        const initialState = {
            currentView: (persisted && persisted.currentView) ? persisted.currentView : 'list',
            activeTabIndex: (persisted && persisted.activeTabIndex !== undefined && persisted.activeTabIndex !== null)
                ? persisted.activeTabIndex
                : -1,
            sectionId: sectionId
        };
        this.states.set(sectionId, new BehaviorSubject(initialState));
    }
    setCurrentView(sectionId, view) {
        const currentState = this.getCurrentState(sectionId);
        this.updateState(sectionId, Object.assign({}, currentState, { currentView: view }));
    }
    setActiveTab(sectionId, tabIndex) {
        const currentState = this.getCurrentState(sectionId);
        this.updateState(sectionId, Object.assign({}, currentState, { activeTabIndex: tabIndex }));
    }
    navigateToCreate(sectionId, tabIndex) {
        const currentState = this.getCurrentState(sectionId);
        const newTabIndex = tabIndex !== undefined ? tabIndex : currentState.activeTabIndex;
        this.updateState(sectionId, {
            currentView: 'create',
            activeTabIndex: newTabIndex,
            sectionId: sectionId
        });
    }
    navigateToList(sectionId) {
        const currentState = this.getCurrentState(sectionId);
        this.updateState(sectionId, Object.assign({}, currentState, { currentView: 'list' }));
    }
    navigateToView(sectionId) {
        const currentState = this.getCurrentState(sectionId);
        this.updateState(sectionId, Object.assign({}, currentState, { currentView: 'view' }));
    }
    navigateToEdit(sectionId) {
        const currentState = this.getCurrentState(sectionId);
        this.updateState(sectionId, Object.assign({}, currentState, { currentView: 'edit' }));
    }
    updateState(sectionId, newState) {
        if (!this.states.has(sectionId)) {
            this.states.set(sectionId, new BehaviorSubject(newState));
        }
        this.states.get(sectionId).next(newState);
        // Persistir el estado
        this.saveToStorage(sectionId, newState);
    }
    reset(sectionId) {
        this.clearPersistedState(sectionId);
        this.initializeSection(sectionId);
    }
    resetAll() {
        this.states.forEach((_, sectionId) => {
            this.clearPersistedState(sectionId);
        });
        this.states.clear();
    }
}
SectionStateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SectionStateService_Factory() { return new SectionStateService(); }, token: SectionStateService, providedIn: "root" });
